<template>
<nav class="navbar header">
  <div class="container is-max-widescreen" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="min-padding navbar-item" href="https://www.kuehne-nagel.com">
        <img src="../assets/kn_logo_standard_positive_rgb.svg" alt="Go to Kuehne+Nagel" width="297" height="58">
      </a>
    </div>
  </div>
</nav>
</template>

<style lang="scss" scoped>
@import '@/theme/theme.scss';
.header {
  background-color: $color-brand-secondary;
}

@media only screen and (max-width: 1023px) {
  .min-padding {
    padding-left: 1.5rem;
  }
}

</style>
